import { channelDisplayName } from "@redotech/redo-merchant-support-app/utils";
import type { TicketChannelCondition as TicketChannelConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { ConversationPlatform } from "@redotech/redo-model/conversation";
import { RedoFilterDropdownAnchor } from "@redotech/redo-web/arbiter-components/filter-group/redo-filter-group";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoMultiselectDropdown } from "@redotech/redo-web/arbiter-components/list/redo-multiselect-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";
import * as styles from "./conditions.module.css";

const channels = Object.values(ConversationPlatform);

export interface TicketChannelConditionProps {
  condition: TicketChannelConditionType;
  onChange: (updated: TicketChannelConditionType) => void;
}

export const TicketChannelCondition = memo(function TicketChannelCondition({
  condition,
  onChange,
}: {
  condition: TicketChannelConditionType;
  onChange: (updated: TicketChannelConditionType) => void;
}) {
  const [dropdownButtonRef, setDropdownButtonRef] =
    useState<HTMLButtonElement | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const channelItems: RedoListItem<ConversationPlatform>[] = useMemo(() => {
    return channels.map((channel) => ({
      id: channel,
      type: "text" as const,
      text: channelDisplayName(channel),
      value: channel,
    }));
  }, []);

  const selectedItems = useMemo(() => {
    return (condition.channels || []).map((channel) => ({
      id: channel,
      type: "text" as const,
      text: channelDisplayName(channel),
      value: channel,
    }));
  }, [condition.channels]);

  const displayText =
    (condition.channels?.length || 0) > 0
      ? condition.channels!.length === 1
        ? // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          channelDisplayName(condition.channels![0])
        : `${condition.channels!.length} channels selected`
      : "Select channels";

  return (
    <Flex dir="column" gap="sm" w="full">
      <div style={{ fontSize: "12px", color: "#666" }}>Channel</div>
      <RedoFilterDropdownAnchor
        className={styles.fullWidthButton}
        color="primary"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        ref={setDropdownButtonRef}
        text={displayText}
      />
      <RedoMultiselectDropdown
        dropdownAnchor={dropdownButtonRef}
        dropdownOpen={dropdownOpen}
        fitToAnchor
        items={channelItems}
        selectedItems={selectedItems}
        selectionVariant="checkbox"
        setDropdownOpen={setDropdownOpen}
        setSelectedItems={(items) => {
          onChange({ ...condition, channels: items.map((item) => item.value) });
        }}
        size="xs"
      />
    </Flex>
  );
});
